import React from 'react';
import { CNavbarBrand } from '@coreui/react';
import logo from '../../assets/img/brand/logo_blue.png';
import { DefaultAppHeaderDropdown } from '../../components';

const SetupAccountHeader: React.FC = () => (
  <>
    <CNavbarBrand href="/#/account/setup" className="p-2">
      <img
        src={logo}
        style={{ width: '100%' }}
        alt="LeadSuite Logo"
        className="sidebar-brand-full"
      />
      <img
        src={logo}
        width={30}
        height={30}
        alt="LeadSuite Logo"
        className="sidebar-brand-narrow"
      />
    </CNavbarBrand>
    <DefaultAppHeaderDropdown onlyLogout />
  </>
);

export default SetupAccountHeader;
